import React from "react";
import { cn } from "@/utils/utils";

interface AnimatedGradientTextProps {
  children: React.ReactNode;
  className?: string;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
}

const AnimatedGradientText: React.FC<AnimatedGradientTextProps> = ({
  children,
  className,
  as = "h2",
}) => {
  const Component = as;

  return (
    <Component
      className={cn(
        "font-display font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-500",
        className
      )}
    >
      {children}
    </Component>
  );
};

export default AnimatedGradientText;

// Add the following CSS to index.css for the text-gradient class
// .text-gradient {
//   @apply bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-500;
// }
